export default {
  loading: 'Preparing a secure connection…',
  secureConnection: 'Secure app connection',
  errorTitle: 'Unable to connect Trainn',
  returnToApp: 'Return to requesting app',
  brandTagline: 'The course-building platform for the AI era',
  introTitle: 'Let AI create, manage and grow',
  introTitleAccent: 'your learning content',
  introDescription:
    'Connect Trainn to your AI assistant and unlock your course workflow, from planning to publishing.',
  connectedWithMcp: 'Connected with MCP',
  benefits: {
    plan: {
      title: 'Create and plan courses',
      description: 'Turn ideas into structured course drafts.'
    },
    library: {
      title: 'Add content and media',
      description: 'Upload, import, and reuse videos and PDFs.'
    },
    academy: {
      title: 'Build and manage courses',
      description: 'Create lessons and prepare courses for learners.'
    }
  },
  signInTitle: 'Sign in to continue',
  signInDescription:
    'Confirm your Trainn account to allow {client} to request access to a workspace.',
  signIn: 'Sign in and continue',
  signInSecurity:
    'Your password and Trainn session are never shared with {client}, and you can revoke access anytime.',
  accessPreviewTitle: '{client} will be able to request access to:',
  accessPreview: {
    library: 'Search, upload, and use learning content from your Library.',
    academy: 'Create and manage course drafts and lessons.'
  },
  trust: {
    security: 'Enterprise-grade security',
    control: 'You stay in control',
    revoke: 'Revoke anytime'
  },
  legalPrefix: 'By continuing, you agree to Trainn’s',
  terms: 'Terms of Service',
  legalAnd: 'and',
  privacy: 'Privacy Policy',
  connectTitle: '{client} wants to connect with Trainn',
  connectDescription:
    'Choose a workspace and set the permissions for this connection.',
  workspaceTitle: 'Select a workspace',
  workspaceDescription: 'Choose the Trainn workspace you want to connect.',
  chooseWorkspace: 'Select a workspace',
  workspaceRole: 'Your role: {role}',
  reconnectWorkspace:
    'To connect a different workspace later, disconnect and reconnect {client}.',
  noWorkspacesTitle: 'No eligible workspaces',
  noWorkspacesDescription:
    'You need an active Trainn workspace membership before you can approve this connection.',
  workspaceUnavailableTag: 'Unavailable',
  workspaceUnavailable: {
    mcp_not_enabled:
      'Trainn MCP is turned off for this workspace. Ask a workspace admin to enable it under Settings → Integrations → Trainn MCP, then connect again.',
    academy_not_enabled:
      'Academy is not available in this workspace. Choose another workspace or reconnect after Academy is enabled.',
    role_restricted: 'Your current Trainn role cannot grant every required permission for this workspace.',
    no_grantable_scopes: 'Your role or workspace policy does not allow the permissions requested by this app.'
  },
  permissionsTitle: 'Set permissions',
  permissionsDescription: 'Choose what {client} can do in this workspace.',
  resetDefaults: 'Reset to defaults',
  required: 'Required',
  noPermissionsTitle: 'No permissions available',
  noPermissionsDescription:
    'This workspace policy does not allow any of the permissions requested by this app.',
  selectWorkspaceFirst: 'Choose a workspace to continue',
  selectWorkspaceDescription:
    'Available permissions depend on your workspace policy and Trainn role.',
  protectedAccess: 'Your access stays protected',
  securityNotice:
    'This app can access only the selected workspace. Your current Trainn role and workspace policy continue to apply to every action.',
  consentAgreement:
    'By allowing access, you authorize {client} to use only the selected permissions. You can revoke this connection later.',
  oauthProtected: 'Protected by OAuth 2.1 and PKCE',
  unknownClient: 'This application',
  allow: 'Allow',
  missingRequest: 'The authorization request is missing or invalid.',
  expiredRequest: 'This authorization request has expired or is no longer available. Start the connection again from your MCP app.',
  consentFailed: 'We could not grant access. Review the workspace and permissions, then try again.',
  cancelFailed: 'We could not return to the requesting app. You can safely close this page.',
  scopeGroups: {
    library: {
      title: 'Library',
      description: 'Browse, upload, import, and inspect reusable learning content.'
    },
    academy: {
      title: 'Academy',
      description: 'View, create, and manage courses and their lessons.'
    }
  },
  scopes: {
    trainn: {
      content: {
        read: {
          title: 'Read Trainn content',
          description: 'Search and read content visible to you in this workspace.'
        },
        write: {
          title: 'Add Trainn content',
          description: 'Upload or import videos and PDF documents into Trainn Library.'
        }
      },
      course: {
        read: {
          title: 'Read courses',
          description: 'View course structure and draft information visible to you.'
        },
        draft: {
          title: 'Create and update course drafts',
          description: 'Create draft courses and edit their structure. Publishing is not included.'
        }
      }
    }
  }
};
